import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SetupDetailView from "./SetupDetailView";
import AddSetupSheet from "./AddSetupSheet";
import api from "../lib/api";

export default function SetupDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [editOpen, setEditOpen] = useState(false);
  const [editSetup, setEditSetup] = useState(null);

  const handleEdit = async (setup) => {
    setEditSetup(setup);
    setEditOpen(true);
  };

  return (
    <div className="p-4 md:p-6 max-w-[1600px] mx-auto" data-testid="setup-detail-page">
      <button
        onClick={() => navigate("/")}
        className="text-xs text-zinc-500 hover:text-white font-display uppercase tracking-wider flex items-center gap-1 mb-4"
        data-testid="btn-back"
      >
        <ArrowLeft size={14} /> Zurück zum Dashboard
      </button>
      <SetupDetailView
        setupId={id}
        onDeleted={() => navigate("/")}
        onEdit={handleEdit}
      />
      <AddSetupSheet
        open={editOpen}
        onOpenChange={setEditOpen}
        editSetup={editSetup}
        onUpdated={() => window.location.reload()}
      />
    </div>
  );
}
